<template>
    <div class="active-user-card">
        <el-card shadow="always">
            <!--<div slot="header" class="clearfix card-title">
        <span>{{ title }}</span>
      </div>-->
            <div class="sign-form-wrap">
                <div class="reset-success-tips">
                    <!--<i :class="(isActivating) ? 'el-icon-loading' : 'el-icon-success'"></i>-->
                    <i class="el-icon-loading" v-if="isActivating"></i>
                    <i class="el-icon-success" v-if="isActivateSuccess"></i>
                    <i class="el-icon-circle-close" v-if="!isActivating && !isActivateSuccess"></i>
                    <h3 class="tips-text">{{ tipsText }}</h3>
                </div>
            </div>
            <div class="card-footer">
                <el-button v-waves class="card-btn-confirm" type="primary" @click="toLogin">{{ $t('Button.ToLogin') }}</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import waves from '@/directive/waves' // Waves directive
import { apiActivateUserAccount } from '@/api/register'
import { FormMixin } from '@/mixins'

export default {
    props: {
        title: { type: String, default: '' },
        resetKey: { type: String, default: '' },
        typeVal: { type: String, default: '' },
    },
    directives: { waves },
    mixins: [FormMixin],
    name: 'ActiveUserCard',
    data() {
        return {
            btnLoading: false,
            isShowCloseIcon: false,
            isActivating: false,
            isActivateSuccess: false,
            accountTypeCHS: { 0: '主账号', 1: '子账号', 3: '协作账号', 4: '换绑账号' },
            accountTypeEN: { 0: 'The Master account', 1: 'The Sub-Account', 3: 'The Assist Account', 4: 'The Changed Account' },
        }
    },
    computed: {
        tipsText() {
            let accountTypeCHS = this.accountTypeCHS[this.typeVal]
            let accountTypeEN = this.accountTypeEN[this.typeVal]
            if (this.isActivating) {
                return this.language === 'zh' ? `${accountTypeCHS}正在激活` : `${accountTypeEN} is being activated`
            } else {
                if (this.isActivateSuccess) {
                    return this.language === 'zh' ? `${accountTypeCHS}已激活` : `${accountTypeEN} has been activated`
                } else {
                    return this.language === 'zh' ? `${accountTypeCHS}激活失败` : `${accountTypeEN} activation failed`
                }
            }
        },
        ...mapGetters(['language']),
    },
    created() {
        this.activeAccount()
    },
    methods: {
        handleCloseClick() {
            this.$emit('close')
        },
        activeAccount() {
            this.btnLoading = true
            this.isActivating = true
            const data = { key: this.resetKey, type: this.typeVal }
            apiActivateUserAccount(data)
                .then(response => {
                    const { data } = response
                    setTimeout(() => {
                        if (data.status === 200) {
                            this.$message.success(data.code ? this.$t('Message.MsgCode' + data.code) : data.msg)
                            this.isActivateSuccess = true
                            this.$emit('activeSuccess')
                        } else {
                            if(this.typeVal == 4){
                                this.$message.error(this.$t('Message.ActivationFails'))
                            }else{
                                this.$message.error(data.code ? this.$t('Message.MsgCode' + data.code) : data.msg)
                            }
                            this.isActivateSuccess = false
                        }
                        this.btnLoading = false
                        this.isActivating = false
                    }, 1000)
                })
                .catch(error => {
                    this.btnLoading = false
                    this.isActivating = false
                })
        },
    },
}
</script>

<style lang="scss" scoped>
$color-theme: #4da1ff;
$normal-color: #aaaaaa;

.active-user-card {
    .el-card {
        padding: 30px 0 20px 0;
    }
    .card-footer {
        .card-btn-confirm {
            width: 60%;
        }
    }
    .sign-form-wrap {
        .reset-success-tips {
            text-align: center;
            .el-icon-loading,
            .el-icon-success {
                font-size: 50px;
                color: $color-theme;
            } //el-icon-success
            .el-icon-circle-close {
                font-size: 50px;
                color: $normal-color;
            } //el-icon-circle-close
            .tips-text {
                margin-top: 15px;
                margin-bottom: 35px;
            } //tips-text
        } //reset-success-tips
    } //sign-form-wrap
}
</style>
